import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-tasks-filter',
  templateUrl: './tasks-filter.component.html',
  styleUrls: ['./tasks-filter.component.css'],
})
export class TasksFilterComponent implements OnInit {
  @Output() filterDataEvent = new EventEmitter<any>();
  formattedFromDate: any = '';
  formattedToDate: any = '';
  todateP: any;
  userdata: any;
  orgId: any;
  taskListData: any[] = [];
  customerList: any[] = [];
  inputFromDate: any = '';
  inputToDate: any= '';
  clientId: any= '';
  constructor(private commonService: CommonService) {}
  toDate: any = '';
  fromDate: any = '';
  searchClients: any = '';
  isClient: boolean = false;
  ngOnInit(): void {
    let userDataObj = localStorage.getItem('userData');
    if (userDataObj) {
      try {
        this.userdata = JSON.parse(userDataObj);

        console.log('Org Id =>', this.userdata.id);
        if (this.userdata.attributes.role === 'admin') {
          this.orgId = this.userdata.id;
        } else if(this.userdata.attributes.role === 'clients'){
          this.isClient=true;
          this.orgId = this.userdata.orgId;
          this.clientId=this.userdata.email;
         
        }
        else{
          this.orgId = this.userdata.orgId;
        }
      } catch (error) {}
    }
    this.getAllCustomers();
  }
  getAllCustomers() {
    this.commonService
      .getRequest(`users?orgId=${this.orgId}`, [])
      .then((resp: any) => {
        if (resp?.status) {
          this.customerList = resp.data;
          this.customerList = this.customerList.filter(
            (customer) => customer.attributes?.role == 'clients'
          );
        }
      });
  }
  convertedDates() {
   debugger
   console.log(this.fromDate+""+ this.toDate)
  if(this.fromDate != '' && this.toDate!= ''){
    this.inputFromDate = new Date(this.fromDate);
    this.inputToDate = new Date(this.toDate);
  this.formattedFromDate = this.inputFromDate.toISOString().slice(0, 10) + 'T00:00:00Z';
  this.formattedToDate = this.inputToDate.toISOString().slice(0, 10) + 'T23:59:59Z';
  }
   
    const assignedTo: any = '';
    const supervisorId: any = '';
if(this.isClient){
  this.commonService
      .getTasks(
        `traccartasks/orgId/${this.orgId}`,
        assignedTo,
        supervisorId,
        this.formattedFromDate,
        this.formattedToDate,
        this.clientId,
        ''
      )
      .subscribe(
        (response) => {
          this.taskListData = response;
          this.sendDataToParent(this.taskListData);
          // Handle the API response here
          console.log(response);
          this.closeForm();
        },
        (error) => {
          // Handle errors here
          console.error(error);
        }
      );
}
else{
  const clientId: any = this.searchClients ? this.searchClients : '';
    this.commonService
      .getTasks(
        `traccartasks/orgId/${this.orgId}`,
        assignedTo,
        supervisorId,
        this.formattedFromDate,
        this.formattedToDate,
        clientId,
        ''
      )
      .subscribe(
        (response) => {
          this.taskListData = response;
          this.sendDataToParent(this.taskListData);
          // Handle the API response here
          console.log(response);
          this.closeForm();
        },
        (error) => {
          // Handle errors here
          console.error(error);
        }
      );
}
  
  }
  sendDataToParent(data: any) {
    // Process your data as needed
    this.filterDataEvent.emit(data);
    // this.closeForm();
  }
  closeForm() {
    this.commonService.commonModel.next(false);
  }

  filteredData() {

    this.formattedFromDate = this.fromDate ? `${this.fromDate}T00:00:00Z` : '';
    this.formattedToDate = this.toDate ? `${this.toDate}T00:00:00Z` : '';
    console.log(this.formattedFromDate);
    console.log(this.formattedToDate);
    const assignedTo: any = '';
    const supervisorId: any = '';
    // const fromDate = this.formattedFromDate ?? '';
    // const toDate = this.formattedFromDate ?? '';
    const clientId: any =this.searchClients ? this.searchClients : '';

    this.commonService
      .getTasks(
        `traccartasks/orgId/${this.orgId}`,
        assignedTo,
        supervisorId,
        this.formattedFromDate,
        this.formattedToDate,
        clientId,
        ''
      )
      .subscribe(
        (response) => {
          this.taskListData = response;
          // Handle the API response here
          console.log(response);
        },
        (error) => {
          // Handle errors here
          console.error(error);
        }
      );
  }
}
